import { Component, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { OverlayService, LangService, AuthService } from 'src/services';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'HUAHAN TECHNOLOGY';
  loading: boolean = false;

  constructor(
    private authService: AuthService,
    private overlayService: OverlayService,
    private titleService: Title,
    private translate: TranslateService,
    private langService: LangService, // 注入 LangService
    private router: Router,
  ) {
    this.langService.transLateInit(); // 调用 LangService 的初始化方法
    this.translate.onLangChange.subscribe(event => {
      this.langService.translate('SITE_TITLE').subscribe(res => {
        this.titleService.setTitle(res)
      })
    });

    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     this.resetScrollPosition();
    //   }
    // });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.overlayService.overlayRef?.hasAttached()) this.overlayService.handleClickOutside(event);
  }

  async ngOnInit() {
    await this.authService.restoreLogin();
  }
  ngAfterViewInit() {
    this.langService.translate('SITE_TITLE').subscribe(res => {
      this.titleService.setTitle(res)
    })
  }

  private resetScrollPosition() {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    scrollToTop();

    requestAnimationFrame(() => {
      scrollToTop();
      requestAnimationFrame(() => {
        scrollToTop();
      });
    });
  }

}
